<template>
  <div
    class="carrer-job-item-wrapper h-full flex flex-col relative"
    data-test-id="component-career-job-item"
  >
    <MajorityUiMajorityLink
      class="link flex flex-col flex-grow link-unstyled hover:underline stretched-link"
      :to="$mRouter.getLocalRoute({name: 'company-career-position-slug', params: { slug: slug }})"
      data-test-id="link-career-job-item-career-details"
    >
      <p class="title text-bigger mb-0 flex-grow">
        {{ title }}
      </p>
    </MajorityUiMajorityLink>
    <p class="opacity-muted mb-0 location">
      {{ city }}
    </p>
    <hr class="my-standart">
  </div>
</template>

<script>
export default {
  name: 'CareerJobItem',
  props: {
    title: {
      type: String,
      required: true
    },
    city: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    }
  }
}
</script>
